<script lang="ts" setup>
import { toRefs } from 'vue';

interface Props {
  message: string;
  details?: string[];
}

const props = defineProps<Props>();

const { message, details } = toRefs(props);
</script>

<template>
  <div class="mt-2 ml-5">
    <Message severity="warn" :closable="false">
      <div class="p-2 pl-0 pr-0 text-base">
        <div class="grid">
          <div class="col-fixed">
            <Icon name="warning" class="text-color-yellow-dark" />
          </div>
          <div class="col mt-1">
            <div>
              <span class="font-semibold">{{ message }}</span>
              <div v-if="details" class="mt-2 w-full">
                <ul v-for="detail of details" :key="detail">
                  <li>{{ detail }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Message>
  </div>
</template>

<style scoped lang="scss">
:deep(.p-message-wrapper) {
  .p-message-icon::before {
    display: none;
  }
}
</style>
